<template>
  <div class="edit_page">
    <div class="edit_wrapper"></div>
    <div class="edit">
      <div class="edit_top">
        <div class="edit_top_buttons">
          <router-link to="/careworkers">
            <input type="button" :value="cancelButton" class="cancel_button" />
          </router-link>
          <input
            type="button"
            :value="addButton"
            class="finish_button"
            @click="showModal = true"
          />
        </div>
      </div>
      <div class="detail">
        <div class="detail_contents">
          <div class="a">
            <div class="pronunciation detail_content">
              <div class="pronunciation_label detail_label">
                {{ pronunciationLabel }}
                <div class="require_items_label">
                  {{ requiredItemLabel }}
                </div>
              </div>
              <input
                class="detail_input_field"
                type="text"
                @input="inputAddUpdate('pronunciation')"
              />
            </div>
            <div class="careworker_name detail_content">
              <div class="careworker_name_label detail_label">
                {{ careworkerNameLabel }}
                <div class="require_items_label">
                  {{ requiredItemLabel }}
                </div>
              </div>
              <input
                class="family_name detail_input_field"
                type="text"
                @input="inputAddUpdate('familyName')"
              />
              <input
                class="name detail_input_field"
                type="text"
                @input="inputAddUpdate('name')"
              />
            </div>
          </div>
          <div class="b">
            <div class="user_id detail_content">
              <div class="user_id_label detail_label">
                {{ userIdLabel }}
                <div class="require_items_label">
                  {{ requiredItemLabel }}
                </div>
              </div>
              <input
                class="user_id detail_input_field"
                type="text"
                @input="inputAddUpdate('userId')"
              />
            </div>
            <div class="post_label detail_label">
              {{ postLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              type="button"
              :value="settingPostButton"
              class="setting_post_button"
              @click="settingPostModal = true"
            />
            <div class="post_name detail_content">
              <div class="post_name_label detail_label">
                {{ mainPostLabel }}
                <div class="require_items_label">
                  {{ requiredItemLabel }}
                </div>
              </div>
              <select
                class="drop_down_list"
                @change="inputPostAddUpdate('postId')"
              >
                <option
                  v-for="post in dropdownPostList"
                  :value="post.postId"
                  :key="post.postId"
                >
                  {{ post.postName }}
                </option>
              </select>
            </div>
            <div class="job detail_content">
              <div class="job_label detail_label">
                {{ jobLabel }}
              </div>
              <input
                class="job detail_input_field"
                type="text"
                @input="inputAddUpdate('job')"
              />
            </div>
            <div class="position detail_content">
              <div class="position_label detail_label">
                {{ positionLabel }}
              </div>
              <input
                class="detail_input_field"
                type="text"
                @input="inputAddUpdate('position')"
              />
            </div>
            <form class="birthday detail_content">
              <div class="birthday_label detail_label">
                {{ birthdayLabel }}
              </div>
              <select class="birthday_drop_down_list" id="year">
                <option v-for="n in 79" :key="n">
                  {{ n + 1900 }}
                </option>
                <option disabled selected>{{ 1980 }}</option>
                <option v-for="n in editYear" :key="n">
                  {{ n + 1980 }}
                </option>
              </select>
              <select class="birthday_drop_down_list" id="month">
                <option v-for="n in 12" :key="n">
                  {{ n }}
                </option>
              </select>
              <select class="birthday_drop_down_list" id="day">
                <option v-for="n in 31" :key="n">
                  {{ n }}
                </option>
              </select>
            </form>
            <div class="memo_detail_content">
              <div class="memo_label detail_label">
                {{ memoLabel }}
              </div>
              <textarea
                class="detail_input_field memo"
                @input="inputAddUpdate('memo')"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="modal_window" v-if="showModal">
        <addModalWindow @close="stayClose" @add="addCareworker">
        </addModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
      <div class="modal_window" v-if="settingPostModal">
        <settingPostModalWindow
          :dispItems="posts"
          :selItems="selectItems"
          @close="closeSettingPostModal"
          @changePost="changePost"
        >
        </settingPostModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import addModalWindow from '../modalWindow/addModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import settingPostModalWindow from '../modalWindow/settingPostModalWindow.vue'

export default {
  data() {
    return {
      cancelButton: 'キャンセル',
      addButton: '追加',
      pronunciationLabel: 'ふりがな',
      careworkerNameLabel: '名前',
      userIdLabel: 'ユーザID',
      postLabel: '所属',
      mainPostLabel: 'メイン所属',
      postIdLabel: '所属ID',
      jobLabel: '職種',
      positionLabel: '役職',
      birthdayLabel: '生年月日',
      memoLabel: '補足情報',
      settingPostButton: '所属の設定',
      completeWord: '',
      failureWord: '',
      selectedPostId: [],
      dropdownPostList: [],
      subPostList: [],
      selectItems: [],
      showModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false,
      settingPostModal: false,
      canselSelectPostId: [],
      selectedMainPostId: ''
    }
  },
  async created() {
    this.showloadingModal = true
    this.selectedPostId = []
    this.dropdownPostList = []
    this.$store.dispatch('careworkers/clearCareworker')
    try {
      await this.$store.dispatch('careworkers/setPost')
      await this.$store.dispatch('careworkers/setSelectedcPost')
    } catch (error) {
      let eventNumber = this.$store.state.error.errorCode.errorCode_370002
      let eventType = 3
      let reason = 'MSGCRC0035 '
      if (error.response) {
        this.failureWord =
          this.errorMsg.MSGCRC0035.name +
          this.errorMsg.MSGCRC0035.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        reason += error.response.status
      } else {
        reason = 'MSGCRC0005'
        eventType = 9
        this.failureWord =
          this.errorMsg.MSGCRC0005.name +
          this.errorMsg.MSGCRC0005.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
      try {
        this.$store.dispatch('masters/writeLog', {
          eventNumber,
          eventType,
          reason
        })
      } catch (error) {}
      this.showFailureModal = true
    }
    this.showloadingModal = false
  },
  computed: {
    editYear() {
      let now = new Date()
      return now.getYear() - 80
    },
    posts() {
      return this.$store.state.careworkers.posts
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    },
    selectedPosts() {
      return this.$store.state.careworkers.selectedposts
    }
  },
  components: {
    addModalWindow,
    completeModalWindow,
    loadingModalWindow,
    settingPostModalWindow
  },
  methods: {
    inputAddUpdate(e) {
      this.$store.dispatch('careworkers/inputAddUpdate', {
        name: e,
        value: event.target.value
      })
    },
    inputPostAddUpdate(e) {
      this.subPostList = []
      this.selectedMainPostId = event.target.value
      for (var i = 0; i < this.dropdownPostList.length; i++) {
        if (event.target.value !== this.dropdownPostList[i]['postId']) {
          let postId = this.dropdownPostList[i]['postId']
          let postCode = this.dropdownPostList[i]['postCode']
          this.subPostList.push({postId, postCode})
        }
      }
      this.$store.dispatch('careworkers/inputAddUpdate', {
        name: e,
        value: this.selectedMainPostId
      })
      this.subPostList.sort(function(a, b) {
        if (a.postCode > b.postCode) {
          return 1
        } else if (a.postCode < b.postCode) {
          return -1
        } else {
          return 0
        }
      })
      for (var j = 0; j < this.subPostList.length; j++) {
        let subPostId = this.subPostList[j]['postId']
        this.$store.dispatch('careworkers/inputAddUpdate', {
          name: 'sub' + [j + 1] + 'PostId',
          value: subPostId
        })
      }
    },
    close(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.$router.push('/careworkers')
      this.settingPostModal = false
    },
    closeSettingPostModal(e) {
      this.settingPostModal = false
      this.selectItems = Array.from(this.canselSelectPostId)
    },
    async changePost(e) {
      this.dropdownPostList = []
      this.canselSelectPostId = []
      this.subPostList = []
      this.selectedPostId = e
      // this.selectedPostIdには所属IDしか持っていないためIDに紐づく情報をthis.dropdownPostListに入れる
      for (var i = 0; i < this.selectedPostId.length; i++) {
        for (var j = 0; j < this.selectedPosts.length; j++) {
          if (this.selectedPostId[i] === this.selectedPosts[j]['postId']) {
            let postId = this.selectedPosts[j]['postId']
            let postName = this.selectedPosts[j]['postName']
            let postCode = this.selectedPosts[j]['postCode']
            this.dropdownPostList.push({postId, postName, postCode})
            this.canselSelectPostId.push(postId)
          }
        }
      }
      this.dropdownPostList.sort(function(a, b) {
        if (a.postCode > b.postCode) {
          return 1
        } else if (a.postCode < b.postCode) {
          return -1
        } else {
          return 0
        }
      })
      let selectedId = this.selectedMainPostId
      var data = this.dropdownPostList.filter(function(row) {
        return row.posId === selectedId
      })
      if (data.length === 0) {
        // メイン所属に設定していた所属のチェックを外した場合
        this.selectedMainPostId = ''
      }

      if (this.selectedMainPostId === '') {
        this.selectedMainPostId = this.dropdownPostList[0]['postId']
      }
      this.$store.dispatch('careworkers/inputAddUpdate', {
        name: 'postId',
        value: this.selectedMainPostId
      })
      for (var k = 0; k < this.dropdownPostList.length; k++) {
        if (this.selectedMainPostId !== this.dropdownPostList[k]['postId']) {
          let postId = this.dropdownPostList[k]['postId']
          let postCode = this.dropdownPostList[k]['postCode']
          this.subPostList.push({postId, postCode})
        }
      }
      this.subPostList.sort(function(a, b) {
        if (a.postCode > b.postCode) {
          return 1
        } else if (a.postCode < b.postCode) {
          return -1
        } else {
          return 0
        }
      })
      // サブ所属の更新は洗い替えする（まずは初期化する）
      this.$store.dispatch('careworkers/inputAddUpdate', {
        name: 'sub1PostId',
        value: ''
      })
      this.$store.dispatch('careworkers/inputAddUpdate', {
        name: 'sub2PostId',
        value: ''
      })
      this.$store.dispatch('careworkers/inputAddUpdate', {
        name: 'sub3PostId',
        value: ''
      })
      this.$store.dispatch('careworkers/inputAddUpdate', {
        name: 'sub4PostId',
        value: ''
      })
      for (var l = 0; l < this.subPostList.length; l++) {
        let subPostId = this.subPostList[l]['postId']
        this.$store.dispatch('careworkers/inputAddUpdate', {
          name: 'sub' + [l + 1] + 'PostId',
          value: subPostId
        })
      }
      this.settingPostModal = false
    },
    stayClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    },
    async addCareworker(e) {
      this.showloadingModal = true
      let year = document.getElementById('year').value
      /** @description new Date()関数のMonth引数調整 */
      let month = Number(document.getElementById('month').value) - 1
      /** @description new Date()関数のDay引数調整 */
      let day = Number(document.getElementById('day').value) + 1
      let birthday = new Date(year, month, day)
      try {
        await this.$store.dispatch('careworkers/addCareworker', birthday)
        this.$emit('list-reload')
        this.showModal = false
        this.completeWord = '追加しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_370001
        let eventType = 3
        let reason = ''
        if (error.response && error.response.data) {
          if (error.response.data.header) {
            let errorMessage = error.response.data.header.message
            if (errorMessage === 'MSGCRC0041') {
              this.failureWord =
                this.errorMsg.MSGCRC0041.name +
                this.errorMsg.MSGCRC0041.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0042') {
              this.failureWord =
                this.errorMsg.MSGCRC0042.name +
                this.errorMsg.MSGCRC0042.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0043') {
              this.failureWord =
                this.errorMsg.MSGCRC0043.name +
                this.errorMsg.MSGCRC0043.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0044') {
              this.failureWord =
                this.errorMsg.MSGCRC0044.name +
                this.errorMsg.MSGCRC0044.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (
              errorMessage === 'MSGCRC0045' ||
              errorMessage === 'MSGCRC0118'
            ) {
              this.failureWord =
                this.errorMsg.MSGCRC0045.name +
                this.errorMsg.MSGCRC0045.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0093') {
              this.failureWord =
                this.errorMsg.MSGCRC0093.name +
                this.errorMsg.MSGCRC0093.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0102') {
              this.failureWord =
                this.errorMsg.MSGCRC0102.name +
                this.errorMsg.MSGCRC0102.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0103') {
              this.failureWord =
                this.errorMsg.MSGCRC0103.name +
                this.errorMsg.MSGCRC0103.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0104') {
              this.failureWord =
                this.errorMsg.MSGCRC0104.name +
                this.errorMsg.MSGCRC0104.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0105') {
              this.failureWord =
                this.errorMsg.MSGCRC0105.name +
                this.errorMsg.MSGCRC0105.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0106') {
              this.failureWord =
                this.errorMsg.MSGCRC0106.name +
                this.errorMsg.MSGCRC0106.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0107') {
              this.failureWord =
                this.errorMsg.MSGCRC0107.name +
                this.errorMsg.MSGCRC0107.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0123') {
              this.failureWord =
                this.errorMsg.MSGCRC0123.name +
                this.errorMsg.MSGCRC0123.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0132') {
              this.failureWord =
                this.errorMsg.MSGCRC0132.name +
                this.errorMsg.MSGCRC0132.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0198') {
              this.failureWord =
                this.errorMsg.MSGCRC0198.name +
                this.errorMsg.MSGCRC0198.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0264') {
              this.failureWord =
                this.errorMsg.MSGCRC0264.name +
                this.errorMsg.MSGCRC0264.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage === 'MSGCRC0273') {
              this.failureWord =
                this.errorMsg.MSGCRC0273.name +
                this.errorMsg.MSGCRC0273.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else {
              this.failureWord =
                this.errorMsg.MSGCRC0046.name +
                this.errorMsg.MSGCRC0046.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            }
            reason = errorMessage + ' '
            reason += error.response.status
          } else {
            var obj = error.response.data
            var stringName = Object.keys(obj)[0]
            if (stringName.endsWith('birthday')) {
              this.failureWord =
                this.errorMsg.MSGCRC0144.name +
                this.errorMsg.MSGCRC0144.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              reason = 'MSGCRC0144'
            } else {
              this.failureWord =
                this.errorMsg.MSGCRC0046.name +
                this.errorMsg.MSGCRC0046.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              reason = 'MSGCRC0046'
            }
          }
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showModal = false
        this.showFailureModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
.detail_contents {
  padding-top: 25px;
}
.detail_content {
  font-size: 0;
}
.detail_top {
  padding-bottom: 25px;
}
.family_name {
  width: 45%;
  border-radius: 3px 0 0 3px;
  border-right: none;
  vertical-align: middle;
}
.name {
  border-radius: 0 3px 3px 0;
  width: 45%;
  vertical-align: middle;
}
.memo {
  resize: vertical;
  min-height: 200px;
  overflow-wrap: anywhere;
  white-space: pre-line;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/careworkers/careworkerAdd.vue